export default "__VITE_ASSET__$yvxbj_S__"